module.exports = __webpack_public_path__ + "static/media/onedrive.6c51a041.svg";